import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const StatusBubble = ({ text }: { text: string }) => {
  return (
    <Box
      sx={{
        alignSelf: 'flex-start',
        px: 1.5,
        py: 1,
        borderRadius: '10px',
        fontSize: 14,
        fontWeight: 500,
        color: 'text.primary',
        background:
          'linear-gradient(90deg, rgba(220,220,220,0.45) 25%, rgba(255,255,255,0.9) 50%, rgba(220,220,220,0.45) 75%)',
        backgroundSize: '200% 100%',
        animation: `${shimmer} 1.6s linear infinite`,
        border: '1px solid',
        borderColor: 'divider',
        width: 'fit-content',
      }}
    >
      {text}
    </Box>
  );
};
